module.exports = __webpack_public_path__ + "static/media/libraBanner.9174001a.png";